import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfnnmh5hv4: FaireProductEntity = {
  token: "p_nfnnmh5hv4",
  type: "product",
  name: "Bulk Loose Wooden Safety Matches \u2013 FSC Certified",
  brandName: "Wax Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/50331a9d924753c2db67e1c2f4980f2eac22111a3544d589876d24d5b99906e8.jpeg",
  priceDollars: 0.02,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f0e8ed1f8c65a9317c0429c53a9bdaa57df3d9bdf5472fc22fce755513036f3d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
